import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = {
  class: "chart-canvas",
  ref: "chartCanvas"
}
const _hoisted_3 = {
  key: 0,
  class: "chart-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512),
    ($setup.chartError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "You must enable Canvas in order to see this element", -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}